import { render, staticRenderFns } from "./ShipmentCmdBox.vue?vue&type=template&id=e2b7a4c8&scoped=true&"
import script from "./ShipmentCmdBox.vue?vue&type=script&lang=js&"
export * from "./ShipmentCmdBox.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCmdBox.vue?vue&type=style&index=0&id=e2b7a4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b7a4c8",
  null
  
)

export default component.exports